export enum TestsheetStatus {
    TO_VALIDATE = '2',
    TO_ARCHIVE = '3',
    ARCHIVED = '4'
}

export type TestsheetListingItem = {
    id: string;
    id_test_sheet: string;
    worksite_id: string;
    apartment_id: string;
    building_id: string;
    status: TestsheetStatus;
    date_create: string;
    done_at: string;
    done_where: string | null;
    batiment: string | null;
    worksite: string;
    title: string;
};

export type TestsheetListingResponse = Array<TestsheetListingItem>;

export type TestsheetModel = {
    id: string;
    title: string;
};

export type GetTestsheetsResponse = Array<TestsheetModel>;

export type Answer = {
    label: string;
    id_answer: string;
};

export type TestsheetQuestion = {
    label: string;
    id_question: string;
    answers: Array<Answer>;
};

export type TestsheetQuiz = Array<{
    label: string;
    id_group: string;
    questions: Array<TestsheetQuestion>;
}>;

export type GetTestsheetsQuizResponse = TestsheetQuiz;

export type CreateTestsheetQuizPayload = {
    worksite_id: number;
    apartment_id?: number;
    building_id?: number;
    test_sheet_id: number;
    observations: string;
    questions: Array<{
        id_question: string;
        id_answer: string;
        comment?: string;
    }>;
};
